// ADR-012 i18n — "tenants" cluster label catalog. Spread into the central LABELS
// in labels.ts. EN values MUST equal the screen's current hardcoded English so
// existing text-based tests stay green; HE values are the Hebrew translation.
export const TENANTS_LABELS = {
  // ═══════════════════════════════════════════════════════════════════════
  //  TenantListPage
  // ═══════════════════════════════════════════════════════════════════════
  tenantListLoading: { en: 'Loading tenants...', he: 'טוען ארגונים...' },
  tenantListTitle: { en: 'Tenants', he: 'ארגונים' },
  tenantListNewTenant: { en: '+ New Tenant', he: '+ ארגון חדש' },
  tenantListLoadError: { en: 'Failed to load tenants.', he: 'טעינת הארגונים נכשלה.' },
  tenantListSuspendPrompt: { en: 'Reason for suspension:', he: 'סיבת ההשעיה:' },
  tenantListSuspendError: { en: 'Failed to suspend tenant.', he: 'השעיית הארגון נכשלה.' },
  tenantListReactivateError: { en: 'Failed to reactivate tenant.', he: 'הפעלת הארגון מחדש נכשלה.' },
  tenantListColName: { en: 'Name', he: 'שם' },
  tenantListColContactEmail: { en: 'Contact Email', he: 'דוא״ל ליצירת קשר' },
  tenantListColPlan: { en: 'Plan', he: 'תוכנית' },
  tenantListColStatus: { en: 'Status', he: 'סטטוס' },
  tenantListColMaxAgents: { en: 'Max Agents', he: 'מקסימום נציגים' },
  tenantListColCreated: { en: 'Created', he: 'נוצר' },
  tenantListColActions: { en: 'Actions', he: 'פעולות' },
  tenantListDeactivate: { en: 'Deactivate', he: 'השבת' },
  tenantListActivate: { en: 'Activate', he: 'הפעל' },

  // ═══════════════════════════════════════════════════════════════════════
  //  TenantFormPage
  // ═══════════════════════════════════════════════════════════════════════
  tenantFormLoading: { en: 'Loading tenant...', he: 'טוען ארגון...' },
  tenantFormEditTitle: { en: 'Edit Tenant', he: 'עריכת ארגון' },
  tenantFormNewTitle: { en: 'New Tenant', he: 'ארגון חדש' },
  tenantFormLoadError: { en: 'Failed to load tenant.', he: 'טעינת הארגון נכשלה.' },
  tenantFormUpdateError: { en: 'Failed to update tenant.', he: 'עדכון הארגון נכשל.' },
  tenantFormContactNameRequired: { en: 'Contact name is required.', he: 'יש להזין שם איש קשר.' },
  tenantFormMaxUsersMin: {
    en: 'Max users must be at least 1.',
    he: 'מספר המשתמשים המרבי חייב להיות לפחות 1.',
  },
  tenantFormAdminRequired: {
    en: 'A valid initial-admin email and display name are required.',
    he: 'יש להזין כתובת דוא״ל ושם תצוגה תקינים למנהל הראשוני.',
  },
  tenantFormCreateError: { en: 'Failed to create tenant.', he: 'יצירת הארגון נכשלה.' },
  tenantFormAdminCreateError: {
    en: 'Tenant created, but the initial admin could not be created.',
    he: 'הארגון נוצר, אך לא ניתן היה ליצור את המנהל הראשוני.',
  },
  tenantFormNameLabel: { en: 'Tenant Name', he: 'שם הארגון' },
  tenantFormContactEmailLabel: { en: 'Contact Email', he: 'דוא״ל ליצירת קשר' },
  tenantFormContactNameLabel: { en: 'Contact Name', he: 'שם איש קשר' },
  tenantFormMaxUsersLabel: { en: 'Max Users (license)', he: 'מקסימום משתמשים (רישיון)' },
  tenantFormPlanTierLabel: { en: 'Plan Tier', he: 'רמת תוכנית' },
  tenantFormPlanFree: { en: 'Free', he: 'חינם' },
  tenantFormPlanStarter: { en: 'Starter', he: 'בסיסי' },
  tenantFormPlanProfessional: { en: 'Professional', he: 'מקצועי' },
  tenantFormPlanEnterprise: { en: 'Enterprise', he: 'ארגוני' },
  tenantFormMaxAgentsLabel: { en: 'Max Agents', he: 'מקסימום נציגים' },
  tenantFormMaxChannelsLabel: { en: 'Max Channels per Bot', he: 'מקסימום ערוצים לבוט' },
  tenantFormInitialAdminLegend: { en: 'Initial admin (required)', he: 'מנהל ראשוני (חובה)' },
  tenantFormInitialAdminHelp: {
    en: 'Every tenant is created with an admin user who receives a one-time temporary password.',
    he: 'כל ארגון נוצר עם משתמש מנהל שמקבל סיסמה זמנית חד-פעמית.',
  },
  tenantFormAdminEmailLabel: { en: 'Admin Email', he: 'דוא״ל המנהל' },
  tenantFormAdminNameLabel: { en: 'Admin Display Name', he: 'שם התצוגה של המנהל' },
  tenantFormSaving: { en: 'Saving...', he: 'שומר...' },
  tenantFormUpdateBtn: { en: 'Update Tenant', he: 'עדכן ארגון' },
  tenantFormCreateBtn: { en: 'Create Tenant', he: 'צור ארגון' },

  // ═══════════════════════════════════════════════════════════════════════
  //  Shared (tenant-scoped pages)
  // ═══════════════════════════════════════════════════════════════════════
  tenantNoTenantSelected: { en: 'No tenant selected.', he: 'לא נבחר ארגון.' },

  // ═══════════════════════════════════════════════════════════════════════
  //  TenantMindPage (Global Mind)
  // ═══════════════════════════════════════════════════════════════════════
  tenantMindLoading: { en: 'Loading Global Mind...', he: 'טוען מוח גלובלי...' },
  tenantMindTitle: { en: 'Global Mind', he: 'מוח גלובלי' },
  tenantMindIntro1: {
    en: 'Organisation-wide identity and rules shared across ',
    he: 'זהות וכללים ברמת הארגון המשותפים ל',
  },
  tenantMindIntroAll: { en: 'all', he: 'כל' },
  tenantMindIntro2: {
    en: " of your agents. The bot sees this on every turn alongside each agent's own settings. Use it for brand voice, prohibited topics, and escalation rules that must apply universally.",
    he: ' הסוכנים שלך. הבוט רואה זאת בכל תור לצד ההגדרות של כל סוכן. השתמש בכך עבור טון המותג, נושאים אסורים וכללי הסלמה שחייבים לחול באופן גורף.',
  },
  tenantMindReadonlyBanner: {
    en: 'You have read-only access to the Global Mind. Contact an administrator to make changes.',
    he: 'יש לך גישת קריאה בלבד למוח הגלובלי. פנה למנהל כדי לבצע שינויים.',
  },
  tenantMindSavedAt: { en: 'Saved at {x}.', he: 'נשמר בשעה {x}.' },
  tenantMindIdentityLabel: { en: 'Identity', he: 'זהות' },
  tenantMindIdentityHelp: {
    en: 'Who this organisation is and what its agents represent. Free-form Markdown; goes into every set of instructions the bot follows.',
    he: 'מיהו הארגון ומה מייצגים הסוכנים שלו. Markdown חופשי; נכנס לכל ההוראות שהבוט פועל לפיהן.',
  },
  tenantMindIdentityPlaceholder: {
    en: 'Acme Support — we help Acme customers with orders, returns, and account questions…',
    he: 'תמיכת Acme — אנו מסייעים ללקוחות Acme בהזמנות, החזרות ושאלות חשבון…',
  },
  tenantMindBrandVoiceLabel: { en: 'Brand voice & tone', he: 'טון וקול המותג' },
  tenantMindBrandVoiceHelp: {
    en: 'How agents should sound. Applies to every agent.',
    he: 'כיצד הסוכנים צריכים להישמע. חל על כל סוכן.',
  },
  tenantMindBrandVoicePlaceholder: {
    en: 'Friendly but professional. Direct, no jargon, no exclamation marks.',
    he: 'ידידותי אך מקצועי. ישיר, ללא ז׳רגון, ללא סימני קריאה.',
  },
  tenantMindProhibitedLabel: { en: 'Prohibited topics', he: 'נושאים אסורים' },
  tenantMindProhibitedHelp1: {
    en: 'Hard limits applying to ',
    he: 'מגבלות מוחלטות החלות על ',
  },
  tenantMindEvery: { en: 'every', he: 'כל' },
  tenantMindProhibitedHelp2: {
    en: ' agent of this tenant. One rule per entry, single sentence — the model attends to short rules better than long paragraphs.',
    he: ' סוכן בארגון זה. כלל אחד לכל שורה, משפט יחיד — המודל מתייחס טוב יותר לכללים קצרים מאשר לפסקאות ארוכות.',
  },
  tenantMindProhibitedPlaceholder: {
    en: 'e.g. Never quote prices in writing',
    he: 'לדוגמה: לעולם אל תצטט מחירים בכתב',
  },
  tenantMindEscalationLabel: { en: 'Escalation rules', he: 'כללי הסלמה' },
  tenantMindEscalationHelp: {
    en: 'Tenant-wide rules for when the bot must hand off to a human agent.',
    he: 'כללים ברמת הארגון למקרים שבהם הבוט חייב להעביר לנציג אנושי.',
  },
  tenantMindEscalationPlaceholder: {
    en: 'e.g. Always offer human contact for billing disputes',
    he: 'לדוגמה: תמיד הצע מעבר לנציג אנושי במחלוקות חיוב',
  },
  tenantMindHagHeading: {
    en: 'Rules to communicate with Human Agent',
    he: 'כללים לתקשורת עם נציג אנושי',
  },
  tenantMindHagHelp1: {
    en: 'Controls how the bot composes messages to your ',
    he: 'קובע כיצד הבוט מנסח הודעות אל ',
  },
  tenantMindHumanTeammates: { en: 'human teammates', he: 'עמיתיך האנושיים' },
  tenantMindHagHelp2: {
    en: ' in the Bot Consultation pane — NOT how it talks to customers. Empty fields fall back to system defaults.',
    he: ' בחלונית ייעוץ הבוט — ולא כיצד הוא מדבר עם לקוחות. שדות ריקים חוזרים לברירות המחדל של המערכת.',
  },
  tenantMindHagLanguageLabel: {
    en: 'Language for bot ↔ human-agent communication',
    he: 'שפה לתקשורת בוט ↔ נציג אנושי',
  },
  tenantMindHagLanguageHelp: {
    en: "Independent of the customer's language. The bot's reply to the customer still matches the customer; only the internal teammate channel uses this language. Leave empty to use the global default (English).",
    he: 'בלתי תלוי בשפת הלקוח. תשובת הבוט ללקוח עדיין תואמת את הלקוח; רק ערוץ העמיתים הפנימי משתמש בשפה זו. השאר ריק כדי להשתמש בברירת המחדל הגלובלית (אנגלית).',
  },
  tenantMindHagLanguagePlaceholder: {
    en: 'e.g. English, Hebrew, עברית',
    he: 'לדוגמה: English, Hebrew, עברית',
  },
  tenantMindHagSectionsLabel: {
    en: 'Data sections the bot must include in every consultation',
    he: 'מקטעי מידע שהבוט חייב לכלול בכל ייעוץ',
  },
  tenantMindHagSectionsHelp1: {
    en: 'Tick the sections you want the bot to ',
    he: 'סמן את המקטעים שברצונך שהבוט ',
  },
  tenantMindAlways: { en: 'always', he: 'תמיד' },
  tenantMindHagSectionsHelp2: {
    en: ' include. Unticked sections are still allowed — the bot uses its judgment per the system prompt.',
    he: ' יכלול. מקטעים שאינם מסומנים עדיין מותרים — הבוט מפעיל שיקול דעת בהתאם לפקודת המערכת.',
  },
  tenantMindSecCustomerQuestion: {
    en: "Customer's verbatim message",
    he: 'ההודעה המדויקת של הלקוח',
  },
  tenantMindSecCustomerQuestionDesc: {
    en: "Quote the customer's most recent message in full.",
    he: 'צטט את ההודעה האחרונה של הלקוח במלואה.',
  },
  tenantMindSecRetrievalFacts: { en: 'Retrieved KB chunks', he: 'קטעי ידע שאוחזרו' },
  tenantMindSecRetrievalFactsDesc: {
    en: 'What the bot found in the knowledge base (or "none").',
    he: 'מה שהבוט מצא במאגר הידע (או "אין").',
  },
  tenantMindSecCertainty: { en: 'Retrieval confidence %', he: 'אחוז ביטחון באחזור' },
  tenantMindSecCertaintyDesc: {
    en: "The bot's certainty score for the retrieved chunks.",
    he: 'ציון הביטחון של הבוט לקטעים שאוחזרו.',
  },
  tenantMindSecExaminer: { en: 'Examiner grade', he: 'ציון הבוחן' },
  tenantMindSecExaminerDesc: {
    en: 'The answer-sufficiency examiner verdict when applicable.',
    he: 'פסיקת בוחן מספיקות התשובה, כאשר רלוונטי.',
  },
  tenantMindSecSuggestedReply: { en: 'Suggested customer reply', he: 'תשובה מוצעת ללקוח' },
  tenantMindSecSuggestedReplyDesc: {
    en: 'The draft message the bot was about to send.',
    he: 'טיוטת ההודעה שהבוט עמד לשלוח.',
  },
  tenantMindSecThreadSummary: { en: 'Recent thread summary', he: 'סיכום שרשור אחרון' },
  tenantMindSecThreadSummaryDesc: {
    en: 'Short recap of the last few customer/bot turns.',
    he: 'תקציר קצר של התורים האחרונים בין הלקוח לבוט.',
  },
  tenantMindCustomLabel: { en: 'Custom data sections', he: 'מקטעי מידע מותאמים אישית' },
  tenantMindCustomHelp: {
    en: 'Tenant-defined extra blocks the bot will include in every consultation message (e.g. compliance reminders, escalation hints). Operator authors each as a name + body pair.',
    he: 'בלוקים נוספים שהארגון מגדיר והבוט יכלול בכל הודעת ייעוץ (למשל תזכורות ציות, רמזי הסלמה). המפעיל כותב כל אחד כזוג של שם + תוכן.',
  },
  tenantMindCustomEmpty: { en: 'No custom sections defined.', he: 'לא הוגדרו מקטעים מותאמים אישית.' },
  tenantMindCustomNamePlaceholder: {
    en: 'Section name (e.g. Compliance reminder)',
    he: 'שם המקטע (למשל תזכורת ציות)',
  },
  tenantMindRemove: { en: 'Remove', he: 'הסר' },
  tenantMindRemoveSectionAria: { en: 'Remove section {n}', he: 'הסר מקטע {n}' },
  tenantMindCustomContentPlaceholder: {
    en: 'Section body — what the bot should include verbatim.',
    he: 'תוכן המקטע — מה שהבוט צריך לכלול מילה במילה.',
  },
  tenantMindAddCustom: { en: '+ Add custom section', he: '+ הוסף מקטע מותאם אישית' },
  tenantMindAdditionalLabel: { en: 'Additional rules', he: 'כללים נוספים' },
  tenantMindAdditionalHelp: {
    en: "Free-form rules appended to the instructions the bot follows when consulting a human teammate. Use to add tenant-specific guidance without rewriting the whole template.",
    he: 'כללים חופשיים שמתווספים להוראות שהבוט פועל לפיהן כשהוא מתייעץ עם נציג אנושי. השתמש כדי להוסיף הנחיות ייחודיות לארגון בלי לשכתב את כל התבנית.',
  },
  tenantMindAdditionalPlaceholder: {
    en: 'e.g. When you escalate, always mention which account tier the customer is on, if known.',
    he: 'לדוגמה: בעת הסלמה, ציין תמיד את רמת החשבון של הלקוח, אם ידועה.',
  },
  tenantMindSaving: { en: 'Saving...', he: 'שומר...' },
  tenantMindSaveBtn: { en: 'Save Global Mind', he: 'שמור מוח גלובלי' },
  tenantMindBackToTenants: { en: 'Back to Tenants', he: 'חזרה לארגונים' },
  tenantMindNotesHeading: { en: 'Machine-curated notes', he: 'הערות שנאספו אוטומטית' },
  tenantMindNotesHelp: {
    en: 'Read-only. Synthesised by the nightly batch from cross-agent patterns and human-agent guidance. Do not rely on these surviving — they get rewritten on every promotion pass.',
    he: 'לקריאה בלבד. מסונתז על ידי התהליך הלילי מדפוסים חוצי-סוכנים והנחיות של נציגים אנושיים. אל תסתמך על שמירתן — הן נכתבות מחדש בכל מחזור קידום.',
  },
  tenantMindLastUpdated: { en: 'Last updated:', he: 'עודכן לאחרונה:' },
  tenantMindNotesEmpty: {
    en: 'No machine-curated notes yet. They appear after the nightly batch promotes patterns up from agent Brains.',
    he: 'עדיין אין הערות שנאספו אוטומטית. הן יופיעו לאחר שהתהליך הלילי מקדם דפוסים ממוחות הסוכנים.',
  },

  // ═══════════════════════════════════════════════════════════════════════
  //  CrmSettingsPage
  // ═══════════════════════════════════════════════════════════════════════
  crmSettingsLoading: { en: 'Loading CRM settings...', he: 'טוען הגדרות CRM...' },
  crmSettingsTitle: { en: 'CRM Integration Settings', he: 'הגדרות אינטגרציית CRM' },
  crmStatusHeading: { en: 'CRM connection', he: 'חיבור CRM' },
  crmStatusLoading: { en: 'Checking the CRM connection...', he: 'בודק את חיבור ה-CRM...' },
  crmStatusLoadFailed: {
    en: "We couldn't check the CRM connection right now.",
    he: 'לא הצלחנו לבדוק את חיבור ה-CRM כרגע.',
  },
  crmStatusCrmLabel: { en: 'CRM', he: 'CRM' },
  crmStatusNotConnected: {
    en: 'Not connected — placeholder only, nothing reaches a real CRM',
    he: 'לא מחובר — ממלא מקום בלבד, דבר אינו מגיע ל-CRM אמיתי',
  },
  crmStatusSourceTenant: { en: 'saved for this organization', he: 'נשמר עבור ארגון זה' },
  crmStatusSourcePlatform: { en: 'platform default', he: 'ברירת מחדל של הפלטפורמה' },
  crmStatusTokenLabel: { en: 'API token', he: 'אסימון API' },
  crmStatusTokenSet: { en: 'Saved — ends in …{x}', he: 'נשמר — מסתיים ב-…{x}' },
  crmStatusTokenSetNoHint: { en: 'Saved', he: 'נשמר' },
  crmStatusTokenLocalDev: { en: '(local development fallback)', he: '(גיבוי לסביבת פיתוח מקומית)' },
  crmStatusTokenNotSet: { en: 'Not set', he: 'לא הוגדר' },
  crmStatusTokenUnknown: {
    en: "Couldn't check right now — try again in a moment",
    he: 'לא ניתן לבדוק כרגע — נסה שוב בעוד רגע',
  },
  crmStatusReadsLabel: { en: 'Reads customer data from the CRM', he: 'קורא נתוני לקוח מה-CRM' },
  crmStatusTicketWritesLabel: { en: 'Writes tickets to the CRM', he: 'כותב כרטיסים ל-CRM' },
  crmStatusContactWritesLabel: { en: 'Creates/updates contacts in the CRM', he: 'יוצר/מעדכן אנשי קשר ב-CRM' },
  crmStatusOn: { en: 'On', he: 'פעיל' },
  crmStatusOff: { en: 'Off', he: 'כבוי' },
  crmStatusSwitchesNote: {
    en: 'These switches are platform settings. A change can take up to 5 minutes to apply.',
    he: 'מתגים אלה הם הגדרות פלטפורמה. שינוי עשוי להימשך עד 5 דקות עד שייכנס לתוקף.',
  },
  crmStatusLastTestLabel: { en: 'Last connection test', he: 'בדיקת החיבור האחרונה' },
  crmStatusLastTestNever: {
    en: 'Never tested — use Test Connection below',
    he: 'לא נבדק מעולם — השתמש ב"בדוק חיבור" למטה',
  },
  crmStatusLastTestOk: { en: 'Connected to account {id} — {when}', he: 'מחובר לחשבון {id} — {when}' },
  crmStatusLastTestSimulated: {
    en: 'Simulated by the placeholder — no real CRM was reached ({when})',
    he: 'הדמיה של ממלא המקום — לא נוצר קשר עם CRM אמיתי ({when})',
  },
  crmStatusLastTestFailed: { en: 'Failed — {when}', he: 'נכשל — {when}' },
  crmSettingsIntro: {
    en: 'Configure the CRM provider for this tenant. Changes take effect on the next session close. The HubSpot Private App token is stored encrypted and is never echoed back.',
    he: 'הגדר את ספק ה-CRM עבור ארגון זה. השינויים ייכנסו לתוקף בסגירת השיחה הבאה. אסימון ה-Private App של HubSpot נשמר מוצפן ולעולם אינו מוחזר.',
  },
  crmSettingsSavedAt: { en: 'Saved at {x}.', he: 'נשמר בשעה {x}.' },
  crmSettingsProviderHeading: { en: 'Provider', he: 'ספק' },
  crmSettingsProviderLabel: { en: 'CRM Provider', he: 'ספק CRM' },
  crmSettingsProviderStub: { en: 'Stub (testing / no CRM)', he: 'Stub (בדיקות / ללא CRM)' },
  crmSettingsProviderHubSpot: { en: 'HubSpot', he: 'HubSpot' },
  crmSettingsTokenHeading: { en: 'HubSpot Private App Token', he: 'אסימון Private App של HubSpot' },
  crmSettingsTokenLabel: { en: 'Private App Token', he: 'אסימון Private App' },
  crmSettingsTokenHelp: {
    en: 'Your token is stored encrypted and never shown again. If you need to rotate it, paste a new value and save.',
    he: 'האסימון שלך נשמר מוצפן ולעולם אינו מוצג שוב. אם יש צורך להחליפו, הדבק ערך חדש ושמור.',
  },
  crmSettingsTokenSavedNotice: {
    en: 'Token saved and encrypted. Paste a new value to rotate.',
    he: 'האסימון נשמר והוצפן. הדבק ערך חדש כדי להחליף.',
  },
  crmSettingsTesting: { en: 'Testing...', he: 'בודק...' },
  crmSettingsTestConnection: { en: 'Test Connection', he: 'בדוק חיבור' },
  crmSettingsConnected: {
    en: 'Connected — Portal ID: {id} | Scopes: {scopes}',
    he: 'מחובר — מזהה פורטל: {id} | הרשאות: {scopes}',
  },
  crmSettingsFailedResult: {
    en: "We couldn't connect. Please check your settings and try again.",
    he: 'לא הצלחנו להתחבר. בדוק את ההגדרות ונסה שוב.',
  },
  crmSettingsTestFailed: {
    en: "We couldn't test the connection right now. Please try again in a moment.",
    he: 'לא הצלחנו לבדוק את החיבור כרגע. נסה שוב בעוד רגע.',
  },
  crmSettingsPipelineHeading: { en: 'Pipeline & Stage Mapping', he: 'מיפוי צינור ושלב' },
  crmSettingsPipelineHelp1: {
    en: 'Chooses the HubSpot pipeline stage a ticket is created at and the stage it is closed at. Click ',
    he: 'בוחר את שלב הצינור ב-HubSpot שבו קריאה נוצרת ואת השלב שבו היא נסגרת. לחץ ',
  },
  crmSettingsRefreshSchema: { en: 'Refresh Schema', he: 'רענן סכימה' },
  crmSettingsPipelineHelp2: {
    en: ' to pull the latest pipelines and property catalog from HubSpot.',
    he: ' כדי למשוך את הצינורות וקטלוג המאפיינים העדכניים מ-HubSpot.',
  },
  crmSettingsRefreshing: { en: 'Refreshing...', he: 'מרענן...' },
  crmSettingsRefreshFailed: {
    en: 'Schema refresh failed. Verify the HubSpot token is set and valid.',
    he: 'רענון הסכימה נכשל. ודא שאסימון HubSpot מוגדר ותקין.',
  },
  crmSettingsLastRefreshed: { en: 'Last refreshed: {x}', he: 'רוענן לאחרונה: {x}' },
  // The two ticket-stage rows. Each writes BOTH keys of its pair (sessionOpened+new, sessionClosed+closed).
  crmSettingsStageTicketCreated: { en: 'Ticket created at stage', he: 'הקריאה נוצרת בשלב' },
  crmSettingsStageTicketClosed: { en: 'Ticket closed at stage', he: 'הקריאה נסגרת בשלב' },
  crmSettingsStageStatusHelp: {
    en: 'A Conversation Status can carry its own stage (set it per Conversation Status); a ticket created by moving a conversation to a status opens at that status’s stage.',
    he: 'לכל סטטוס שיחה יכול להיות שלב משלו (מגדירים אותו בכל סטטוס שיחה); קריאה שנוצרת בעקבות העברת שיחה לסטטוס נפתחת בשלב של אותו סטטוס.',
  },
  crmSettingsNoStageMapped: { en: '(no stage mapped)', he: '(לא מופה שלב)' },
  crmSettingsNoPipelines: {
    en: 'No pipelines discovered yet — run a refresh to populate this list.',
    he: 'עדיין לא נמצאו צינורות — בצע רענון כדי למלא רשימה זו.',
  },
  crmSettingsNoProperties: {
    en: 'No properties discovered yet — run a refresh to populate the catalog.',
    he: 'עדיין לא נמצאו מאפיינים — בצע רענון כדי למלא את הקטלוג.',
  },
  crmSettingsContextHeading: { en: 'CRM Context Fields', he: 'שדות הקשר של CRM' },
  crmSettingsContextHelp: {
    en: "Select which HubSpot contact properties are folded into the instructions the bot follows at chat time (e.g. hs_lead_status, lifecyclestage, hs_analytics_source).",
    he: 'בחר אילו מאפייני איש קשר של HubSpot ישולבו בהוראות שהבוט פועל לפיהן בזמן הצ׳אט (למשל hs_lead_status, lifecyclestage, hs_analytics_source).',
  },
  crmSettingsExportHeading: { en: 'Export Settings', he: 'הגדרות ייצוא' },
  crmSettingsExportToggleLabel: {
    en: 'Enable CRM export on session close',
    he: 'אפשר ייצוא ל-CRM בסגירת שיחה',
  },
  crmSettingsExportHelp: {
    en: 'When enabled, the bot creates / updates a HubSpot contact and ticket after every session closes. Disable to pause all exports without changing the provider.',
    he: 'כאשר מופעל, הבוט יוצר / מעדכן איש קשר וכרטיס ב-HubSpot לאחר כל סגירת שיחה. השבת כדי להשהות את כל הייצוא בלי לשנות את הספק.',
  },
  crmSettingsChannelMapHeading: {
    en: 'Channel Source Mapping (read-only)',
    he: 'מיפוי מקור ערוץ (לקריאה בלבד)',
  },
  crmSettingsChannelMapHelp: {
    en: 'Support-system channel types map to HubSpot source types as follows. This mapping is fixed in v1 and not operator-configurable.',
    he: 'סוגי הערוצים של מערכת התמיכה ממופים לסוגי המקור של HubSpot כמפורט להלן. מיפוי זה קבוע בגרסה 1 ואינו ניתן להגדרה על ידי המפעיל.',
  },
  crmSettingsChannelColCss: { en: 'Support-system channel', he: 'ערוץ מערכת התמיכה' },
  crmSettingsChannelColHubSpot: { en: 'HubSpot source', he: 'מקור HubSpot' },
  crmSettingsSaving: { en: 'Saving...', he: 'שומר...' },
  crmSettingsSaveBtn: { en: 'Save CRM Settings', he: 'שמור הגדרות CRM' },
  crmSettingsLedgerHeading: { en: 'Export Ledger', he: 'יומן ייצוא' },
  crmSettingsLedgerHelp: {
    en: 'Closed-session CRM export jobs. Dead rows (max retries exceeded) can be retried once the underlying issue is resolved (e.g. token rotated, HubSpot restored).',
    he: 'משימות ייצוא ל-CRM של שיחות סגורות. שורות מתות (חריגה ממספר הניסיונות המרבי) ניתנות לניסיון חוזר לאחר פתרון הבעיה הבסיסית (למשל החלפת אסימון, שחזור HubSpot).',
  },
  crmSettingsFilterAll: { en: 'All statuses', he: 'כל הסטטוסים' },
  crmSettingsFilterPending: { en: 'Pending', he: 'ממתין' },
  crmSettingsFilterExported: { en: 'Exported', he: 'יוצא' },
  crmSettingsFilterFailed: { en: 'Failed', he: 'נכשל' },
  crmSettingsFilterDead: { en: 'Dead', he: 'מת' },
  crmSettingsRefresh: { en: 'Refresh', he: 'רענן' },
  crmSettingsLoadingExports: { en: 'Loading exports...', he: 'טוען ייצואים...' },
  crmSettingsNoExports: { en: 'No export records found.', he: 'לא נמצאו רשומות ייצוא.' },
  crmSettingsLedgerColSession: { en: 'Session', he: 'שיחה' },
  crmSettingsLedgerColStatus: { en: 'Status', he: 'סטטוס' },
  crmSettingsLedgerColAttempts: { en: 'Attempts', he: 'ניסיונות' },
  crmSettingsLedgerColExportedAt: { en: 'Exported at', he: 'יוצא בתאריך' },
  crmSettingsLedgerColAction: { en: 'Action', he: 'פעולה' },
  crmSettingsRetrying: { en: 'Retrying...', he: 'מנסה שוב...' },
  crmSettingsPrevious: { en: 'Previous', he: 'הקודם' },
  crmSettingsNext: { en: 'Next', he: 'הבא' },
  crmSettingsPageOf: { en: 'Page {x} of {y}', he: 'עמוד {x} מתוך {y}' },

  // ═══════════════════════════════════════════════════════════════════════
  //  UserListPage
  // ═══════════════════════════════════════════════════════════════════════
  userListLoading: { en: 'Loading users...', he: 'טוען משתמשים...' },
  userListTitle: { en: 'Users', he: 'משתמשים' },
  userListNewUser: { en: '+ New User', he: '+ משתמש חדש' },
  userListLoadError: { en: 'Failed to load users.', he: 'טעינת המשתמשים נכשלה.' },
  userListSelectTenant: {
    en: 'Select a tenant in the header to manage its users.',
    he: 'בחר ארגון בכותרת כדי לנהל את המשתמשים שלו.',
  },
  userListColDisplayName: { en: 'Display Name', he: 'שם תצוגה' },
  userListColEmail: { en: 'Email', he: 'דוא״ל' },
  userListColRole: { en: 'Role', he: 'תפקיד' },
  userListColStatus: { en: 'Status', he: 'סטטוס' },
  userListColLastLogin: { en: 'Last Login', he: 'כניסה אחרונה' },
  userListColActions: { en: 'Actions', he: 'פעולות' },
  userListActive: { en: 'Active', he: 'פעיל' },
  userListInactive: { en: 'Inactive', he: 'לא פעיל' },
  userListLockedTitle: {
    en: 'Locked after too many failed logins',
    he: 'ננעל לאחר יותר מדי ניסיונות כניסה כושלים',
  },
  userListLocked: { en: '🔒 Locked', he: '🔒 נעול' },
  userListDeactivate: { en: 'Deactivate', he: 'השבת' },
  userListActivate: { en: 'Activate', he: 'הפעל' },
  userListResetPassword: { en: 'Reset Password', he: 'אפס סיסמה' },
  userListUnlock: { en: 'Unlock', he: 'שחרר נעילה' },
  userListConfirmDeactivate: { en: 'Deactivate {name}?', he: 'להשבית את {name}?' },
  userListConfirmActivate: { en: 'Activate {name}?', he: 'להפעיל את {name}?' },
  userListDeactivateError: { en: 'Failed to deactivate user.', he: 'השבתת המשתמש נכשלה.' },
  userListActivateError: { en: 'Failed to activate user.', he: 'הפעלת המשתמש נכשלה.' },
  userListConfirmReset: {
    en: 'Issue a new temporary password for {name}?',
    he: 'להנפיק סיסמה זמנית חדשה עבור {name}?',
  },
  userListResetError: { en: 'Failed to reset password.', he: 'איפוס הסיסמה נכשל.' },
  userListConfirmUnlock: {
    en: 'Unlock {name}? This clears the failed-attempt lock without changing their password.',
    he: 'לשחרר את נעילת {name}? פעולה זו מנקה את נעילת הניסיונות הכושלים בלי לשנות את הסיסמה.',
  },
  userListUnlockError: { en: 'Failed to unlock user.', he: 'שחרור נעילת המשתמש נכשל.' },
  userListConfirmDelete: {
    en: 'Delete {name}? This cannot be undone.',
    he: 'למחוק את {name}? לא ניתן לבטל פעולה זו.',
  },
  userListDeleteError: { en: 'Failed to delete user.', he: 'מחיקת המשתמש נכשלה.' },

  // ═══════════════════════════════════════════════════════════════════════
  //  UserFormPage
  // ═══════════════════════════════════════════════════════════════════════
  userFormNewTitle: { en: 'New User', he: 'משתמש חדש' },
  userFormEditTitle: { en: 'Edit User', he: 'עריכת משתמש' },
  userFormLoading: { en: 'Loading user...', he: 'טוען משתמש...' },
  userFormCreateError: { en: 'Failed to create user.', he: 'יצירת המשתמש נכשלה.' },
  userFormLoadError: { en: 'Failed to load user.', he: 'טעינת המשתמש נכשלה.' },
  userFormUpdateError: { en: 'Failed to update user.', he: 'עדכון המשתמש נכשל.' },
  userFormEmailLabel: { en: 'Email', he: 'דוא״ל' },
  userFormDisplayNameLabel: { en: 'Display Name', he: 'שם תצוגה' },
  userFormMainRoleLabel: { en: 'Main Role', he: 'תפקיד ראשי' },
  userFormDeveloperAccess: {
    en: 'Developer access — can view audit logs & technical logs used for troubleshooting',
    he: 'גישת מפתח — יכול לצפות ביומני ביקורת ובלוגים טכניים המשמשים לפתרון תקלות',
  },
  userFormActiveLabel: { en: 'Active — the user can sign in', he: 'פעיל — המשתמש יכול להתחבר' },
  userFormCreating: { en: 'Creating...', he: 'יוצר...' },
  userFormCreateBtn: { en: 'Create User', he: 'צור משתמש' },
  userFormSaving: { en: 'Saving...', he: 'שומר...' },
  userFormSaveChanges: { en: 'Save Changes', he: 'שמור שינויים' },

  // ═══════════════════════════════════════════════════════════════════════
  //  TenantEraseModal
  // ═══════════════════════════════════════════════════════════════════════
  tenantEraseAriaLabel: { en: 'Delete tenant', he: 'מחיקת ארגון' },
  tenantEraseTitle: { en: 'Permanently delete “{name}”', he: 'מחיקה לצמיתות של “{name}”' },
  tenantEraseWarn1: { en: 'This ', he: 'פעולה זו ' },
  tenantEraseWarnStrong1: { en: 'permanently erases', he: 'מוחקת לצמיתות' },
  tenantEraseWarn2: { en: ' the tenant and ', he: ' את הארגון ו' },
  tenantEraseWarnStrong2: {
    en: 'all of its data across every service',
    he: 'את כל הנתונים שלו בכל השירותים',
  },
  tenantEraseWarn3: {
    en: '. This cannot be undone. Make sure a database backup exists first.',
    he: '. לא ניתן לבטל פעולה זו. ודא תחילה שקיים גיבוי של מסד הנתונים.',
  },
  tenantErasePartial: {
    en: 'Partial failure — some services did not complete. The tenant was NOT removed and can be retried.',
    he: 'כשל חלקי — חלק מהשירותים לא הושלמו. הארגון לא הוסר וניתן לנסות שוב.',
  },
  tenantErasePwFailed: {
    en: 'Password verification failed. Please re-enter your password.',
    he: 'אימות הסיסמה נכשל. אנא הזן שוב את הסיסמה.',
  },
  tenantEraseFailed: { en: 'Erasure failed. Please try again.', he: 'המחיקה נכשלה. אנא נסה שוב.' },
  tenantEraseStillRunning: {
    en: 'This is still running in the background. Check the tenant list in a few minutes before trying again.',
    he: 'התהליך עדיין רץ ברקע. בדוק את רשימת הארגונים בעוד כמה דקות לפני שתנסה שוב.',
  },
  tenantEraseTypeName: {
    en: 'Type the tenant name to confirm:',
    he: 'הקלד את שם הארגון כדי לאשר:',
  },
  tenantErasePasswordLabel: { en: 'Your password', he: 'הסיסמה שלך' },
  tenantEraseDeleting: { en: 'Deleting…', he: 'מוחק…' },
  tenantEraseDeleteBtn: { en: 'Delete tenant', he: 'מחק ארגון' },

  // ═══════════════════════════════════════════════════════════════════════
  //  TempPasswordModal
  // ═══════════════════════════════════════════════════════════════════════
  tempPasswordTitle: { en: 'Temporary password', he: 'סיסמה זמנית' },
  tempPasswordFor: { en: 'For', he: 'עבור' },
  tempPasswordCopied: { en: 'Copied', he: 'הועתק' },
  tempPasswordCopy: { en: 'Copy', he: 'העתק' },
  tempPasswordWarning: {
    en: 'This password is shown only once. Share it securely; the user must change it at first login.',
    he: 'סיסמה זו מוצגת פעם אחת בלבד. שתף אותה בצורה מאובטחת; המשתמש חייב לשנות אותה בכניסה הראשונה.',
  },
  tempPasswordDismiss: { en: "I've saved it", he: 'שמרתי אותה' },

  // ═══════════════════════════════════════════════════════════════════════
  //  RoleBadge
  // ═══════════════════════════════════════════════════════════════════════
  roleBadgeDevTitle: { en: 'Developer access', he: 'גישת מפתח' },
  roleBadgeDevChip: { en: 'DEV', he: 'DEV' },

  // ═══════════════════════════════════════════════════════════════════════
  //  ConversationStatesPage (ADR-017 — per-tenant conversation states; on screen: "Conversation Statuses", PR-A)
  // ═══════════════════════════════════════════════════════════════════════
  convStatesTitle: { en: 'Conversation Statuses', he: 'סטטוסי שיחה' },
  convStatesSubtitle: {
    en: 'The statuses agents use to sort live conversations in the Agent Console; each can map to a HubSpot pipeline stage.',
    he: 'הסטטוסים שבהם הנציגים ממיינים שיחות בקונסולת הנציגים; ניתן למפות כל סטטוס לשלב בצינור HubSpot.',
  },
  convStatesLoading: { en: 'Loading conversation statuses…', he: 'טוען סטטוסי שיחה…' },
  convStatesLoadError: { en: 'Failed to load conversation statuses.', he: 'טעינת סטטוסי השיחה נכשלה.' },
  convStatesNew: { en: '+ New Status', he: '+ סטטוס חדש' },
  convStatesEmpty: {
    en: 'No conversation statuses yet — add one or import from your HubSpot pipeline.',
    he: 'אין עדיין סטטוסי שיחה — הוסיפו סטטוס או ייבאו מצינור ה-HubSpot שלכם.',
  },
  convStatesColLabel: { en: 'Label', he: 'תווית' },
  convStatesColKey: { en: 'Key', he: 'מזהה' },
  convStatesColColor: { en: 'Color', he: 'צבע' },
  convStatesColOrder: { en: 'Order', he: 'סדר' },
  convStatesColLifecycle: { en: 'Lifecycle', he: 'מחזור חיים' },
  convStatesColCrmStage: { en: 'CRM stage', he: 'שלב CRM' },
  convStatesColDefault: { en: 'Default', he: 'ברירת מחדל' },
  convStatesColActive: { en: 'Active', he: 'פעיל' },
  convStatesColActions: { en: 'Actions', he: 'פעולות' },
  convStatesConsoleOnly: { en: 'console only', he: 'קונסולה בלבד' },
  convStatesFormCreateTitle: { en: 'New conversation status', he: 'סטטוס שיחה חדש' },
  convStatesFormEditTitle: { en: 'Edit conversation status', he: 'עריכת סטטוס שיחה' },
  convStatesFieldKey: { en: 'Key (slug — immutable after create)', he: 'מזהה (קבוע לאחר יצירה)' },
  convStatesFieldLabelEn: { en: 'Label (English)', he: 'תווית (אנגלית)' },
  convStatesFieldLabelHe: { en: 'Label (Hebrew)', he: 'תווית (עברית)' },
  convStatesFieldColor: { en: 'Color', he: 'צבע' },
  convStatesFieldOrder: { en: 'Order', he: 'סדר' },
  convStatesFieldLifecycle: { en: 'Maps to lifecycle (advisory)', he: 'ממופה למחזור חיים (מייעץ)' },
  convStatesFieldCrmStage: {
    en: 'CRM stage ref — "pipelineId::stageId" (optional)',
    he: 'הפניית שלב CRM — "pipelineId::stageId" (לא חובה)',
  },
  convStatesFieldDefault: { en: 'Default status for new conversations', he: 'סטטוס ברירת מחדל לשיחות חדשות' },
  convStatesFieldActive: { en: 'Active', he: 'פעיל' },
  convStatesFieldAutoTrigger: { en: 'Auto-move here when…', he: 'העבר לכאן אוטומטית כאשר…' },
  convStatesColAutoTrigger: { en: 'Auto trigger', he: 'טריגר אוטומטי' },
  convStatesAutoTriggerNone: { en: 'Never (manual only)', he: 'אף פעם (ידני בלבד)' },
  convStatesAutoTriggerAiTurn: { en: "It's the bot's turn (new chat / customer replied)", he: 'תור הבוט (שיחה חדשה / הלקוח הגיב)' },
  convStatesAutoTriggerClientTurn: { en: 'Bot replied — waiting on the customer', he: 'הבוט הגיב — ממתין ללקוח' },
  convStatesAutoTriggerAgentConsult: { en: 'Bot asked a human for help (consultation)', he: 'הבוט ביקש עזרה מנציג (התייעצות)' },
  convStatesAutoTriggerHumanTakeover: { en: 'A human agent took over', he: 'נציג אנושי השתלט על השיחה' },
  convStatesAutoTriggerClosed: { en: 'Conversation closed', he: 'השיחה נסגרה' },
  convStatesValidationRequired: {
    en: 'Key, English label and Hebrew label are required.',
    he: 'מזהה, תווית אנגלית ותווית עברית הם שדות חובה.',
  },
  convStatesSaveError: {
    en: 'Could not save the status. Check the fields and try again.',
    he: 'שמירת הסטטוס נכשלה. בדוק את השדות ונסה שוב.',
  },
  convStatesDeleteConfirm: {
    en: 'Delete this conversation status? A status that a conversation still uses cannot be deleted — deactivate it instead.',
    he: 'למחוק סטטוס שיחה זה? לא ניתן למחוק סטטוס ששיחה עדיין משתמשת בו — יש להשבית אותו במקום.',
  },
  convStatesDeleteError: { en: 'Could not delete the status.', he: 'מחיקת הסטטוס נכשלה.' },

  // PR-A — import a HubSpot pipeline's stages as conversation statuses. HE NEEDS NATIVE REVIEW.
  convStatesImportOpen: { en: 'Import stages from HubSpot pipeline…', he: 'ייבוא שלבים מצינור HubSpot…' },
  convStatesImportTitle: { en: 'Import stages from a HubSpot pipeline', he: 'ייבוא שלבים מצינור HubSpot' },
  convStatesImportIntro: {
    en: 'Each stage of the pipeline becomes a conversation status mapped to that stage. Stages imported before are skipped, so running it again only adds new stages.',
    he: 'כל שלב בצינור הופך לסטטוס שיחה הממופה לאותו שלב. שלבים שיובאו בעבר מדולגים, כך שהרצה חוזרת מוסיפה רק שלבים חדשים.',
  },
  convStatesImportPipeline: { en: 'Pipeline', he: 'צינור' },
  convStatesImportPickPipeline: { en: 'Choose a pipeline…', he: 'בחרו צינור…' },
  convStatesImportLoading: { en: 'Loading pipelines…', he: 'טוען צינורות…' },
  convStatesImportNoPipelines: {
    en: 'No HubSpot pipelines are available. Connect HubSpot in Settings → CRM first.',
    he: 'אין צינורות HubSpot זמינים. חברו את HubSpot תחילה בהגדרות ← CRM.',
  },
  convStatesImportColStage: { en: 'Stage', he: 'שלב' },
  convStatesImportColClosed: { en: 'Closed stage', he: 'שלב סגור' },
  convStatesImportColStatus: { en: 'Already imported', he: 'יובא כבר' },
  convStatesImportYes: { en: 'Yes', he: 'כן' },
  convStatesImportNo: { en: 'No', he: 'לא' },
  convStatesImportNoStages: { en: 'This pipeline has no stages.', he: 'אין שלבים בצינור הזה.' },
  convStatesImportConfirm: { en: 'Import', he: 'ייבוא' },
  convStatesImportBusy: { en: 'Importing…', he: 'מייבא…' },
  convStatesImportClose: { en: 'Close', he: 'סגירה' },
  convStatesImportResult: {
    en: '{created} created, {matched} already present.',
    he: '{created} נוצרו, {matched} כבר קיימים.',
  },
  convStatesImportError: {
    en: 'The stages were not imported. Nothing was changed.',
    he: 'השלבים לא יובאו. שום דבר לא שונה.',
  },

  // ═══════════════════════════════════════════════════════════════════════
  //  CRM property mapping (CRM v2 WS-3.3) — Settings → Property Mapping
  //
  //  Every property input on this screen is a PICKER over the discovered
  //  catalog, so there is deliberately no "type the property name" label
  //  here: free-text property entry is the defect this screen removes.
  // ═══════════════════════════════════════════════════════════════════════
  crmMappingTabLabel: { en: 'Property Mapping', he: 'מיפוי שדות' },
  crmMappingTitle: { en: 'CRM Property Mapping', he: 'מיפוי שדות CRM' },
  crmMappingIntro: {
    en: 'Decide which Botablex field lands in which CRM property. Every target is picked from your portal’s own discovered schema, so a property name is never typed by hand.',
    he: 'קבע איזה שדה של Botablex נכתב לאיזו תכונה ב-CRM. כל יעד נבחר מהסכימה שגילינו בפורטל שלך, כך שאין צורך להקליד שם תכונה.',
  },
  crmMappingLoading: { en: 'Loading the CRM mapping…', he: 'טוען את מיפוי ה-CRM…' },
  crmMappingNoTenant: { en: 'No tenant selected.', he: 'לא נבחר ארגון.' },
  crmMappingSaveBtn: { en: 'Save mapping', he: 'שמור מיפוי' },
  crmMappingSaving: { en: 'Saving…', he: 'שומר…' },
  crmMappingSavedAt: { en: 'Mapping saved at {x}.', he: 'המיפוי נשמר ב-{x}.' },
  crmMappingTagsRowHeld: {
    en: 'The conversation-tags row was saved OFF. A new tags row never writes to the CRM until you tick Enabled and save a second time.',
    he: 'שורת תגיות השיחה נשמרה כבויה. שורת תגיות חדשה אינה כותבת ל-CRM עד שמסמנים "פעיל" ושומרים פעם שנייה.',
  },
  crmMappingVersionLine: {
    en: 'Mapping v{v} · portal schema v{s} · discovered {d}',
    he: 'מיפוי גרסה {v} · סכימת פורטל גרסה {s} · גולתה ב-{d}',
  },

  // ── Schema refresh + catalog states ───────────────────────────────────
  crmMappingRefreshSchema: { en: 'Refresh schema', he: 'רענן סכימה' },
  crmMappingRefreshing: { en: 'Refreshing…', he: 'מרענן…' },
  crmMappingRefreshFailed: {
    en: 'The CRM portal could not be read, so the schema was NOT refreshed. Everything below is still the last catalog we discovered successfully.',
    he: 'לא ניתן היה לקרוא את פורטל ה-CRM, ולכן הסכימה לא רועננה. כל המוצג להלן הוא עדיין הקטלוג האחרון שגילינו בהצלחה.',
  },
  crmMappingRefreshedOk: {
    en: 'Schema refreshed — now portal schema v{s}.',
    he: 'הסכימה רועננה — סכימת הפורטל כעת גרסה {s}.',
  },
  crmMappingCatalogEmptyTitle: {
    en: 'This portal’s schema has not been discovered yet',
    he: 'סכימת הפורטל הזה עדיין לא גולתה',
  },
  crmMappingCatalogEmptyBody: {
    en: 'A mapping is authored by picking from your portal’s real properties, so discovery has to run first. Open the CRM tab, use Refresh Schema there, then come back.',
    he: 'המיפוי נבנה מבחירה מתוך התכונות האמיתיות בפורטל שלך, ולכן תחילה יש להריץ גילוי. עבור ללשונית CRM, הפעל שם "רענן סכימה", וחזור לכאן.',
  },

  // ── Staleness banner ─────────────────────────────────────────────────
  crmMappingStaleTitle: {
    en: 'This mapping no longer matches the portal',
    he: 'המיפוי הזה אינו תואם עוד לפורטל',
  },
  crmMappingStaleBody: {
    en: 'Something changed in the CRM after this mapping was authored. Until it is fixed, the affected rows write nothing.',
    he: 'משהו השתנה ב-CRM לאחר שהמיפוי נכתב. עד לתיקון, השורות המושפעות אינן כותבות דבר.',
  },
  crmMappingStaleKindPropertyRemoved: { en: 'Property removed from the portal', he: 'התכונה הוסרה מהפורטל' },
  crmMappingStaleKindPropertyTypeChanged: { en: 'Property type changed', he: 'סוג התכונה השתנה' },
  crmMappingStaleKindPropertyNoLongerWritable: {
    en: 'Property no longer accepts writes',
    he: 'התכונה אינה מקבלת עוד כתיבה',
  },
  crmMappingStaleKindEnumOptionRemoved: { en: 'A mapped option value was removed', he: 'אחד מערכי הרשימה הממופים הוסר' },
  crmMappingStaleKindCardinalityChanged: { en: 'Single/multi-select changed', he: 'בחירה בודדת/מרובה השתנתה' },
  crmMappingStaleKindOwnerDeactivated: { en: 'Assigned owner was deactivated', he: 'הבעלים המשויך הושבת' },
  crmMappingStaleKindOwnerRemoved: { en: 'Assigned owner no longer exists', he: 'הבעלים המשויך אינו קיים עוד' },
  crmMappingStaleKindUnknown: { en: 'Portal change', he: 'שינוי בפורטל' },

  // ── Validation ───────────────────────────────────────────────────────
  crmMappingValidating: { en: 'Checking the mapping…', he: 'בודק את המיפוי…' },
  crmMappingValidOk: { en: 'No problems found. This mapping can be saved.', he: 'לא נמצאו בעיות. ניתן לשמור את המיפוי.' },
  crmMappingDocIssuesHeading: { en: 'Problems with the mapping as a whole', he: 'בעיות במיפוי כמכלול' },
  crmMappingWarningsAdvisory: {
    en: 'Warnings are advisory — they do not block saving.',
    he: 'אזהרות הן מידע בלבד — הן אינן מונעות שמירה.',
  },
  crmMappingSaveRejectedTitle: { en: 'Nothing was saved', he: 'שום דבר לא נשמר' },
  crmMappingSaveRejectedBody: {
    en: 'The server refused this mapping and did NOT persist any part of it. The saved mapping is unchanged. Fix the problems marked below and save again.',
    he: 'השרת דחה את המיפוי הזה ולא שמר שום חלק ממנו. המיפוי השמור לא השתנה. תקן את הבעיות המסומנות למטה ושמור שוב.',
  },
  crmMappingRowLabel: { en: 'Row {n}', he: 'שורה {n}' },

  // ── Issue codes ──────────────────────────────────────────────────────
  crmMappingCodeUnknownBotablexKey: { en: 'Unknown Botablex field', he: 'שדה Botablex לא מוכר' },
  crmMappingCodeObjectTypeNotAllowed: { en: 'Not allowed on this object', he: 'לא מותר על אובייקט זה' },
  crmMappingCodeDirectionNotAllowed: { en: 'Direction not supported', he: 'הכיוון אינו נתמך' },
  crmMappingCodeTargetPropertyMissing: { en: 'Target property missing', he: 'תכונת היעד חסרה' },
  crmMappingCodeTargetNotWritable: { en: 'Target is not writable', he: 'לא ניתן לכתוב ליעד' },
  crmMappingCodeTargetReserved: { en: 'Target is reserved by the integration', he: 'היעד שמור לאינטגרציה' },
  crmMappingCodeValueMapRequired: { en: 'Value map required', he: 'נדרש מיפוי ערכים' },
  crmMappingCodeValueMapTargetUnknown: { en: 'The portal does not accept this value', he: 'הפורטל אינו מקבל ערך זה' },
  crmMappingCodeValueMapTargetHidden: { en: 'Option is hidden in the portal', he: 'האפשרות מוסתרת בפורטל' },
  crmMappingCodeCardinalityMismatch: { en: 'Single/multi mismatch', he: 'אי-התאמה בין בודד למרובה' },
  crmMappingCodeTypeIncompatible: { en: 'Incompatible types', he: 'סוגים לא תואמים' },
  crmMappingCodeDuplicateTarget: { en: 'Two rows write the same property', he: 'שתי שורות כותבות לאותה תכונה' },
  crmMappingCodeCatalogMissing: { en: 'No discovered schema', he: 'אין סכימה שגולתה' },
  crmMappingCodeOwnerNotActive: { en: 'Owner is deactivated', he: 'הבעלים מושבת' },
  crmMappingCodeOwnerUnknown: { en: 'Owner not in this portal', he: 'הבעלים אינו קיים בפורטל זה' },
  crmMappingCodeEngagementKindUnsupported: { en: 'Unsupported conversation surface', he: 'משטח שיחה שאינו נתמך' },
  crmMappingCodeIdentityPropertyMissing: { en: 'Identity property missing', he: 'תכונת זיהוי חסרה' },
  crmMappingCodeConversationPropertyMissing: {
    en: 'Conversation property missing from the portal', he: 'תכונת השיחה חסרה בפורטל',
  },
  crmMappingCodeConversationPropertyNotEditable: {
    en: 'The portal will not accept edits to this property', he: 'הפורטל לא מקבל עריכה לתכונה זו',
  },
  crmMappingCodeConversationPropertyReserved: {
    en: 'Reserved by the integration — cannot be editable', he: 'שמור לאינטגרציה — לא ניתן לעריכה',
  },
  crmMappingCodeConversationPropertyAlsoWritten: {
    en: 'Also written automatically by a field row', he: 'נכתב גם אוטומטית על ידי שורת מיפוי',
  },
  // ADR-033 D11: the conversation-tags row (session.tags)
  crmMappingCodeTagsTargetNotEnumeration: {
    en: 'Tags can only go into a list property', he: 'תגיות יכולות להיכתב רק לתכונת רשימה',
  },
  crmMappingCodeTagsTargetSingleSelect: {
    en: 'Single-select property: only the first tag is written', he: 'תכונת בחירה יחידה: רק התגית הראשונה נכתבת',
  },
  crmMappingCodeValueMapSourceUnknown: {
    en: 'Not a tag in this tenant’s tag catalog', he: 'אינה תגית בקטלוג התגיות של הדייר',
  },
  // OP-1508: the old text said tags MUST map to a multi-select property; the server accepts a single-select one with a
  // warning and writes the first mapped tag. Say what actually happens.
  crmMappingTagsHelp: {
    en: 'Map tags to a multi-select (checkbox) property to keep every tag of a conversation; on a single-select property only the first mapped tag is written. Only the portal option VALUES are written, never the labels.',
    he: 'מפו תגיות לתכונת בחירה מרובה (תיבות סימון) כדי לשמור את כל התגיות של שיחה; בתכונת בחירה יחידה נכתבת רק התגית הממופה הראשונה. נכתבים רק ערכי האפשרויות בפורטל, לעולם לא התוויות.',
  },
  crmMappingTagsUnavailable: {
    en: 'The tag catalog could not be loaded, so tag keys have to be typed. Reload the page to try again.',
    he: 'לא ניתן היה לטעון את קטלוג התגיות, ולכן יש להקליד מפתחות תגיות. טען את הדף מחדש כדי לנסות שוב.',
  },
  crmMappingValueMapTagInactive: { en: 'inactive', he: 'לא פעילה' },
  crmMappingValueMapTagUnknown: { en: 'unknown tag: {key}', he: 'תגית לא מוכרת: {key}' },
  crmMappingValueMapTagChoose: { en: 'Choose a tag', he: 'בחירת תגית' },

  // ── Section 1: customer model (read-only mirror) ──────────────────────
  crmMappingCustomerModelHeading: { en: 'Customer model', he: 'מודל הלקוחות' },
  crmMappingCustomerModelHelp: {
    en: 'Whether this tenant’s customers are private individuals, people at companies, or both. It decides whether the company section below applies at all.',
    he: 'האם לקוחות הארגון הזה הם אנשים פרטיים, אנשים בחברות, או שניהם. הבחירה קובעת אם מקטע החברה שלהלן רלוונטי בכלל.',
  },
  crmMappingCustomerModelPrivate: { en: 'Private individuals', he: 'אנשים פרטיים' },
  crmMappingCustomerModelCompanies: { en: 'People at companies', he: 'אנשים בחברות' },
  crmMappingCustomerModelBoth: { en: 'Both', he: 'שניהם' },
  crmMappingCustomerModelUnknown: {
    en: 'Not set — treated as private individuals',
    he: 'לא הוגדר — מטופל כאנשים פרטיים',
  },
  crmMappingCustomerModelOwnedElsewhere: {
    en: 'Owned by Settings → General (CRM section) and shown here read-only, so there is only ever one place to change it.',
    he: 'מנוהל ב"הגדרות → כללי" (מקטע CRM) ומוצג כאן לקריאה בלבד, כדי שיהיה רק מקום אחד לשנות אותו.',
  },
  crmMappingCustomerModelOpenSettings: { en: 'Open Tenant Settings', he: 'פתח הגדרות ארגון' },

  // ── Sections 2 + 3: identity ─────────────────────────────────────────
  crmMappingCompanyHeading: { en: 'Company identity', he: 'זיהוי חברה' },
  crmMappingCompanyHelp: {
    en: 'How a company is recognised in your portal and what is shown about it. Required while the customer model includes companies.',
    he: 'כיצד חברה מזוהה בפורטל שלך ומה מוצג עליה. נדרש כאשר מודל הלקוחות כולל חברות.',
  },
  crmMappingCompanyHiddenNote: {
    en: 'The customer model is set to private individuals, so no company is ever resolved and this section does not apply.',
    he: 'מודל הלקוחות מוגדר לאנשים פרטיים, ולכן חברה אינה מזוהה כלל והמקטע הזה אינו רלוונטי.',
  },
  crmMappingContactHeading: { en: 'Contact identity', he: 'זיהוי איש קשר' },
  crmMappingContactHelp: {
    en: 'How the person is recognised in your portal and what is shown about them.',
    he: 'כיצד האדם מזוהה בפורטל שלך ומה מוצג עליו.',
  },
  crmMappingExternalIdLabel: { en: 'Your own id property', he: 'תכונת המזהה שלך' },
  crmMappingExternalIdHelp: {
    en: 'The portal property holding YOUR identifier for this record. The same concept is often spelled differently on contacts and on companies — which is exactly why it is picked and not typed.',
    he: 'התכונה בפורטל שמחזיקה את המזהה שלך לרשומה. אותו מושג מאוית לעתים אחרת על איש קשר ועל חברה — בדיוק הסיבה שבוחרים ולא מקלידים.',
  },
  crmMappingDisplayLabel: { en: 'Name property', he: 'תכונת השם' },
  crmMappingDisplayHelp: {
    en: 'The portal property shown as this record’s name in the bot context and the agent console.',
    he: 'התכונה בפורטל שתוצג כשם הרשומה בהקשר הבוט ובקונסולת הנציג.',
  },
  crmMappingContextLabel: { en: 'Context properties', he: 'תכונות הקשר' },
  crmMappingContextHelp: {
    en: 'Extra portal properties pulled into the bot’s context and the agent console. Read-side only — nothing here is ever written back.',
    he: 'תכונות נוספות מהפורטל שנשלפות להקשר הבוט ולקונסולת הנציג. קריאה בלבד — שום דבר כאן אינו נכתב חזרה.',
  },
  crmMappingContextAdd: { en: 'Add', he: 'הוסף' },
  crmMappingContextRemove: { en: 'Remove {item}', he: 'הסר את {item}' },
  crmMappingContextEmpty: { en: 'None selected.', he: 'לא נבחרו.' },
  crmMappingContextAllUsed: {
    en: 'Every discovered property on this object is already selected.',
    he: 'כל התכונות שגולו על האובייקט הזה נבחרו כבר.',
  },

  // ── Section 4: field-mapping rows ────────────────────────────────────
  crmMappingFieldsHeading: { en: 'Field mapping', he: 'מיפוי שדות' },
  crmMappingFieldsHelp: {
    en: 'One row per field written to or read from the CRM. Both sides are pickers: the left from the Botablex field catalog, the right from your portal’s discovered properties.',
    he: 'שורה לכל שדה שנכתב או נקרא מה-CRM. שני הצדדים הם רשימות בחירה: השמאלי מקטלוג השדות של Botablex, הימני מהתכונות שגולו בפורטל שלך.',
  },
  crmMappingAddRow: { en: '+ Add field', he: '+ הוסף שדה' },
  crmMappingNoRows: { en: 'No fields are mapped yet.', he: 'עדיין לא מופה אף שדה.' },
  crmMappingColBotablex: { en: 'Botablex field', he: 'שדה Botablex' },
  crmMappingColObjectType: { en: 'CRM object', he: 'אובייקט CRM' },
  crmMappingColTarget: { en: 'CRM property', he: 'תכונת CRM' },
  crmMappingColDirection: { en: 'Direction', he: 'כיוון' },
  crmMappingColValueMap: { en: 'Values', he: 'ערכים' },
  crmMappingColEnabled: { en: 'Active', he: 'פעיל' },
  crmMappingColActions: { en: 'Actions', he: 'פעולות' },
  crmMappingRowNewTitle: { en: 'New field mapping', he: 'מיפוי שדה חדש' },
  crmMappingRowEditTitle: { en: 'Edit field mapping', he: 'עריכת מיפוי שדה' },
  crmMappingRowApply: { en: 'Apply', he: 'החל' },
  // Tags mapping hunt (OP-1506): Apply and the Active box only STAGE a change; say so.
  crmMappingRowApplyHelp: {
    en: 'Apply puts this row into the table below. Nothing is stored until you press "Save mapping" at the bottom of the page.',
    he: '"החל" מכניס את השורה לטבלה שלהלן. דבר לא נשמר עד שתלחצו על "שמור מיפוי" בתחתית העמוד.',
  },
  crmMappingUnsaved: {
    en: 'Changes on this page are not saved yet. Nothing reaches the mapping (or the CRM) until you press "Save mapping".',
    he: 'השינויים בעמוד זה לא נשמרו עדיין. דבר לא נכנס למיפוי (או ל-CRM) עד שתלחצו על "שמור מיפוי".',
  },
  crmMappingRowIncomplete: {
    en: 'Pick a Botablex field and a CRM property before applying the row.',
    he: 'בחר שדה Botablex ותכונת CRM לפני החלת השורה.',
  },
  crmMappingEnabledAria: {
    en: 'Active — clear to park this row without deleting it',
    he: 'פעיל — בטל כדי להשעות את השורה בלי למחוק אותה',
  },
  crmMappingDirectionOutbound: { en: 'Botablex → CRM (write)', he: 'Botablex → CRM (כתיבה)' },
  crmMappingDirectionInbound: { en: 'CRM → Botablex (read)', he: 'CRM → Botablex (קריאה)' },
  crmMappingDirectionBoth: { en: 'Both ways', he: 'בשני הכיוונים' },
  crmMappingObjectTypeContacts: { en: 'Contact', he: 'איש קשר' },
  crmMappingObjectTypeCompanies: { en: 'Company', he: 'חברה' },
  crmMappingObjectTypeTickets: { en: 'Ticket', he: 'כרטיס' },
  crmMappingMultiValueLabel: { en: 'Target accepts several values', he: 'היעד מקבל כמה ערכים' },
  crmMappingMultiValueHelp: {
    en: 'Set from the portal’s own control type when the property is picked — a multi-select target is written ‘;’-joined.',
    he: 'נקבע לפי סוג הפקד בפורטל בזמן בחירת התכונה — יעד מרובה-בחירה נכתב מחובר בתו ‘;’.',
  },
  crmMappingDeleteRowTitle: { en: 'Delete this field mapping?', he: 'למחוק את מיפוי השדה הזה?' },
  crmMappingDeleteRowBody: {
    en: 'The row is removed from the mapping. Nothing already written to the CRM changes. To stop writing a field without losing its setup, clear Active instead.',
    he: 'השורה תוסר מהמיפוי. שום דבר שנכתב כבר ל-CRM לא ישתנה. כדי להפסיק לכתוב שדה בלי לאבד את ההגדרה שלו, בטל את "פעיל" במקום זאת.',
  },

  // ── Value-map sub-editor ─────────────────────────────────────────────
  crmMappingValueMapHeading: { en: 'Value map', he: 'מיפוי ערכים' },
  crmMappingValueMapHelp: {
    en: 'This CRM property is a list, so each Botablex value needs an explicit portal value. The picker holds this property’s own options and binds to the STORED value, never to the label displayed beside it.',
    he: 'תכונת ה-CRM הזו היא רשימה, ולכן לכל ערך של Botablex נדרש ערך פורטל מפורש. הרשימה מציגה את האפשרויות של התכונה עצמה ונקשרת לערך המאוחסן, לא לתווית שמוצגת לידו.',
  },
  crmMappingValueMapSourceLabel: { en: 'Botablex value', he: 'ערך Botablex' },
  crmMappingValueMapTargetLabel: { en: 'Portal option', he: 'אפשרות בפורטל' },
  crmMappingValueMapAdd: { en: '+ Add value', he: '+ הוסף ערך' },
  crmMappingValueMapRemove: { en: 'Remove the value {item}', he: 'הסר את הערך {item}' },
  crmMappingValueMapEmpty: {
    en: 'No values mapped yet — add one for each Botablex value you expect.',
    he: 'עדיין לא מופו ערכים — הוסף אחד לכל ערך Botablex שאתה מצפה לו.',
  },
  crmMappingValueMapNoOptions: {
    en: 'This property reports no options of its own (its values come from an external source), so a value entered here is accepted as-is.',
    he: 'התכונה הזו אינה מדווחת על אפשרויות משלה (ערכיה מגיעים ממקור חיצוני), ולכן ערך שיוזן כאן יתקבל כפי שהוא.',
  },

  // ── Pickers ──────────────────────────────────────────────────────────
  crmMappingPickerChoose: { en: '— pick a property —', he: '— בחר תכונה —' },
  crmMappingPickerChooseBotablex: { en: '— pick a Botablex field —', he: '— בחר שדה Botablex —' },
  crmMappingPickerChooseOption: { en: '— pick an option —', he: '— בחר אפשרות —' },
  crmMappingPickerChooseOwner: { en: '— pick an owner —', he: '— בחר בעלים —' },
  crmMappingPickerUngrouped: { en: 'Other properties', he: 'תכונות אחרות' },
  crmMappingPickerReadOnlySuffix: { en: 'read-only in the portal', he: 'לקריאה בלבד בפורטל' },
  crmMappingPickerCalculatedSuffix: { en: 'calculated by the portal', he: 'מחושב על ידי הפורטל' },
  crmMappingPickerNoProperties: {
    en: 'No properties were discovered for this object.',
    he: 'לא גולו תכונות עבור האובייקט הזה.',
  },

  // ── Section 5: owners ────────────────────────────────────────────────
  crmMappingOwnersHeading: { en: 'Owners', he: 'בעלים' },
  crmMappingOwnersHelp: {
    en: 'Which portal user a ticket is assigned to. Rows are keyed on the staff email — the only identifier both systems share, since two portal owners can carry the same display name.',
    he: 'לאיזה משתמש בפורטל משויך כרטיס. השורות ממופתחות לפי דוא"ל העובד — המזהה היחיד המשותף לשתי המערכות, מכיוון ששני בעלים בפורטל יכולים לשאת אותו שם תצוגה.',
  },
  crmMappingOwnerColEmail: { en: 'Staff email', he: 'דוא"ל עובד' },
  crmMappingOwnerColOwner: { en: 'Portal owner', he: 'בעלים בפורטל' },
  crmMappingOwnerColActions: { en: 'Actions', he: 'פעולות' },
  crmMappingOwnerAddEmailLabel: { en: 'Staff email to map', he: 'דוא"ל עובד למיפוי' },
  crmMappingOwnerAdd: { en: 'Add owner mapping', he: 'הוסף מיפוי בעלים' },
  crmMappingOwnerRemove: { en: 'Remove the owner mapping for {item}', he: 'הסר את מיפוי הבעלים של {item}' },
  crmMappingOwnerEmailInvalid: { en: 'Enter a staff email address first.', he: 'הזן קודם כתובת דוא"ל של עובד.' },
  crmMappingOwnerEmailDuplicate: { en: 'That email is already mapped.', he: 'הדוא"ל הזה כבר ממופה.' },
  crmMappingOwnersEmpty: { en: 'No staff are mapped to portal owners yet.', he: 'עדיין לא מופו עובדים לבעלים בפורטל.' },
  crmOwnerRosterHelp: {
    en: 'Every BotableX user is connected automatically to the CRM user with the same email. Pick a different CRM user to override it. Users marked Notice have no CRM user, so tickets they handle go to the owner representing the bot (below), or stay unassigned.',
    he: 'כל משתמש ב-BotableX מחובר אוטומטית למשתמש ה-CRM בעל אותו דוא"ל. בחר משתמש CRM אחר כדי לעקוף זאת. משתמשים המסומנים "שים לב" אינם קיימים ב-CRM, ולכן כרטיסים שהם מטפלים בהם עוברים לבעלים של הבוט שלהלן, או נשארים ללא שיוך.',
  },
  crmOwnerRosterEmpty: { en: 'No BotableX users found.', he: 'לא נמצאו משתמשי BotableX.' },
  crmOwnerRosterLoading: { en: 'Loading BotableX users...', he: 'טוען משתמשי BotableX...' },
  crmOwnerRosterUnavailable: {
    en: "BotableX users couldn't be loaded, so they can't be listed here. You can still map a staff email by hand.",
    he: 'לא ניתן היה לטעון את משתמשי BotableX, ולכן לא ניתן להציגם כאן. עדיין אפשר למפות דוא"ל של עובד ידנית.',
  },
  crmOwnerRosterColUser: { en: 'BotableX user', he: 'משתמש BotableX' },
  crmOwnerRosterColStatus: { en: 'Status', he: 'סטטוס' },
  crmOwnerRosterPickerAria: { en: 'CRM owner for {user}', he: 'בעלים ב-CRM עבור {user}' },
  crmOwnerRosterUnassigned: { en: '— not assigned —', he: '— ללא שיוך —' },
  crmOwnerRosterAuto: { en: 'Connected automatically (same email)', he: 'חובר אוטומטית (אותו דוא"ל)' },
  crmOwnerRosterManual: { en: 'Set manually', he: 'הוגדר ידנית' },
  crmOwnerRosterUseAutomatic: { en: 'Use automatic', he: 'השתמש באוטומטי' },
  crmOwnerRosterNotice: { en: 'Notice:', he: 'שים לב:' },
  crmOwnerRosterNotFound: {
    en: 'not found as a user in the CRM — no CRM user has this email.',
    he: 'לא נמצא כמשתמש ב-CRM — לאף משתמש ב-CRM אין דוא"ל זה.',
  },
  crmOwnerRosterInactive: {
    en: "the CRM user with this email is deactivated, so tickets won't be assigned to them.",
    he: 'משתמש ה-CRM בעל דוא"ל זה מושבת, ולכן כרטיסים לא ישויכו אליו.',
  },
  crmOwnerRosterNoCatalog: {
    en: 'CRM users have not been loaded yet — refresh the CRM schema to match by email.',
    he: 'משתמשי ה-CRM עדיין לא נטענו — רענן את סכימת ה-CRM כדי להתאים לפי דוא"ל.',
  },
  crmOwnerRosterOrphan: {
    en: 'this email is not a BotableX user.',
    he: 'דוא"ל זה אינו משתמש ב-BotableX.',
  },
  crmMappingOwnersNoneDiscovered: {
    en: 'No portal owners were discovered, so there is nothing to pick from. Refresh the schema once the portal has users.',
    he: 'לא גולו בעלים בפורטל, ולכן אין ממה לבחור. רענן את הסכימה לאחר שיהיו משתמשים בפורטל.',
  },
  crmMappingOwnerInactive: { en: 'deactivated', he: 'מושבת' },
  crmMappingOwnerInactiveWarning: {
    en: 'This owner is deactivated in the portal. Tickets assigned to them will not appear in any active user’s queue.',
    he: 'הבעלים הזה מושבת בפורטל. כרטיסים שיוקצו לו לא יופיעו בתור של אף משתמש פעיל.',
  },
  crmMappingBotOwnerLabel: { en: 'Owner representing the bot', he: 'בעלים שמייצג את הבוט' },
  crmMappingBotOwnerHelp: {
    en: 'Assigned to tickets the bot resolved on its own. Picked from the discovered owners — this replaces the owner id that used to be pasted in by hand on the CRM tab.',
    he: 'משויך לכרטיסים שהבוט פתר בעצמו. נבחר מתוך הבעלים שגולו — מחליף את מזהה הבעלים שהודבק בעבר ידנית בלשונית CRM.',
  },
  crmMappingBotOwnerNone: { en: 'None — leave bot tickets unassigned', he: 'ללא — השאר כרטיסי בוט ללא שיוך' },

  // ── Section 6: engagement strategy ───────────────────────────────────
  crmMappingEngagementHeading: { en: 'Conversation record per channel', he: 'רשומת שיחה לכל ערוץ' },
  crmMappingEngagementHelp: {
    en: 'Which CRM object carries the per-message record for each channel. An email thread belongs on an email record and a WhatsApp exchange on a communication — putting both on a note loses the channel in the CRM timeline.',
    he: 'איזה אובייקט ב-CRM נושא את רשומת ההודעות לכל ערוץ. שרשור דוא"ל שייך לרשומת דוא"ל ושיחת וואטסאפ לרשומת תקשורת — הכנסת שניהם לפתקית מאבדת את הערוץ בציר הזמן של ה-CRM.',
  },
  crmMappingEngagementColChannel: { en: 'Channel', he: 'ערוץ' },
  crmMappingEngagementColKind: { en: 'CRM record', he: 'רשומת CRM' },
  crmMappingEngagementKindNote: { en: 'Note', he: 'פתקית' },
  crmMappingEngagementKindEmails: { en: 'Email', he: 'דוא"ל' },
  crmMappingEngagementKindCommunications: { en: 'Communication (WhatsApp / SMS)', he: 'תקשורת (וואטסאפ / SMS)' },
  crmMappingEngagementKindCalls: { en: 'Call', he: 'שיחת טלפון' },

  // ── Section 7: conversation properties (the agent's panel card) ─────
  crmMappingConvPropsHeading: {
    en: 'Conversation properties', he: 'תכונות שיחה',
  },
  crmMappingConvPropsHelp: {
    en: 'Choose which of your ticket properties appear on an agent’s conversation panel. Tick Editable only where an agent should be able to change the value — that writes straight to your CRM.',
    he: 'בחר אילו מתכונות הכרטיס יופיעו בפאנל השיחה של הנציג. סמן "לעריכה" רק במקום שנציג אמור לשנות את הערך — זה נכתב ישירות ל-CRM.',
  },
  crmMappingConvPropsAdd: { en: 'Add property', he: 'הוסף תכונה' },
  crmMappingConvPropsColProperty: { en: 'Ticket property', he: 'תכונת כרטיס' },
  crmMappingConvPropsColEditable: { en: 'Editable by agents', he: 'ניתן לעריכה' },
  crmMappingConvPropsColOrder: { en: 'Order', he: 'סדר' },
  crmMappingConvPropsColActions: { en: 'Actions', he: 'פעולות' },
  crmMappingConvPropsRemove: { en: 'Remove {item}', he: 'הסר {item}' },
  crmMappingConvPropsUp: { en: 'Move up', he: 'העלה' },
  crmMappingConvPropsDown: { en: 'Move down', he: 'הורד' },
  crmMappingConvPropsNone: {
    en: 'No conversation properties yet. Agents will see only the conversation details.',
    he: 'אין עדין תכונות שיחה. נציגים יראו רק את פרטי השיחה.',
  },
  crmMappingConvPropsWriteWarning: {
    en: 'Editable properties are written to your live CRM the moment an agent changes them.',
    he: 'תכונות לעריכה נכתבות ל-CRM החי ברגע שנציג משנה אותן.',
  },

  // ── Preview ──────────────────────────────────────────────────────────
  crmMappingPreviewHeading: { en: 'What will be written', he: 'מה ייכתב בפועל' },
  crmMappingPreviewHelp: {
    en: 'Rendered by the same code the CRM writers use, so this is the actual payload — not an illustration. Enter a sample value for any Botablex field and run it.',
    he: 'מופק על ידי אותו קוד שמשמש את כותבי ה-CRM, ולכן זו המטענה האמיתית — לא הדגמה. הזן ערך לדוגמה לכל שדה Botablex והרץ.',
  },
  crmMappingPreviewRun: { en: 'Run preview', he: 'הרץ תצוגה מקדימה' },
  crmMappingPreviewRunning: { en: 'Rendering…', he: 'מפיק…' },
  crmMappingPreviewFailed: { en: 'The preview could not be rendered.', he: 'לא ניתן היה להפיק את התצוגה המקדימה.' },
  crmMappingPreviewSampleHeading: { en: 'Sample Botablex values', he: 'ערכי Botablex לדוגמה' },
  crmMappingPreviewSampleEmpty: {
    en: 'Map at least one field to preview a payload.',
    he: 'מפה שדה אחד לפחות כדי לראות תצוגה מקדימה.',
  },
  crmMappingPreviewEmpty: {
    en: 'Nothing would be written from these sample values.',
    he: 'שום דבר לא ייכתב מערכי הדוגמה האלה.',
  },
  crmMappingPreviewPayloadFor: { en: 'Payload written to {x}', he: 'מטענה שתיכתב ל-{x}' },
  crmMappingPreviewColProperty: { en: 'CRM property', he: 'תכונת CRM' },
  crmMappingPreviewColValue: { en: 'Value', he: 'ערך' },
  crmMappingPreviewSkippedHeading: { en: 'Rows that produced nothing', he: 'שורות שלא הפיקו דבר' },
  crmMappingPreviewColReason: { en: 'Why', he: 'מדוע' },
  crmMappingSkipDisabled: { en: 'The row is parked', he: 'השורה מושעית' },
  crmMappingSkipInboundOnly: { en: 'Read-only row — nothing to write', he: 'שורת קריאה בלבד — אין מה לכתוב' },
  crmMappingSkipNoSourceValue: { en: 'No sample value was supplied', he: 'לא סופק ערך לדוגמה' },
  crmMappingSkipTargetMissing: {
    en: 'The target property is not in the current schema',
    he: 'תכונת היעד אינה בסכימה הנוכחית',
  },
  crmMappingSkipTargetNotWritable: {
    en: 'The portal will not accept a write to the target',
    he: 'הפורטל לא יקבל כתיבה ליעד',
  },
  crmMappingSkipValueNotMapped: {
    en: 'The value has no entry in this row’s value map',
    he: 'לערך אין רשומה במיפוי הערכים של השורה',
  },
  crmMappingSkipValueNotOffered: {
    en: 'The portal no longer offers the mapped option, so it is not sent. Refresh the schema and fix the value map.',
    he: 'הפורטל כבר לא מציע את האפשרות הממופה, ולכן היא לא נשלחת. רעננו את הסכימה ותקנו את מיפוי הערכים.',
  },
  crmMappingSkipTargetReserved: { en: 'The target is reserved by the integration', he: 'היעד שמור לאינטגרציה' },
  crmMappingSkipUnknown: { en: 'Skipped', he: 'נדלג' },

  // ── PR-B B5: a save refused because the stored mapping moved on (409 mapping_changed) ──
  crmMappingChangedBanner: {
    en: 'Someone else changed this mapping (for example, a tag or status import) while you were editing. The page has been reloaded with the latest version — please re-apply your changes.',
    he: 'מישהו אחר שינה את המיפוי (למשל ייבוא תגיות או סטטוסים) בזמן שערכת. הדף נטען מחדש עם הגרסה העדכנית — יש להחיל שוב את השינויים.',
  },

  // ── PR-B B6: one-step option import from the row editor (tags or Conversation Statuses) ──
  crmOptionImportTitle: { en: 'Import options from this property', he: 'ייבוא אפשרויות מהשדה' },
  crmOptionImportIntroTags: {
    en: 'Creates a BotableX tag for each of the {n} options of "{p}" and connects each one to its option in the value map, in one step. Existing tags are reused. Only this row is saved; your other unsaved changes on this page are kept, but anything not yet applied in this editor is replaced.',
    he: 'יוצר תגית ב-BotableX לכל אחת מ-{n} האפשרויות של "{p}" ומחבר כל אחת לאפשרות שלה במיפוי הערכים, בצעד אחד. תגיות קיימות משמשות שוב. רק השורה הזו נשמרת; שאר השינויים שלא נשמרו בעמוד נשארים, אך כל מה שעדיין לא הוחל בעורך זה יוחלף.',
  },
  crmOptionImportIntroStatuses: {
    en: 'Creates a Conversation Status for each of the {n} options of "{p}" and connects each one to its option in the value map, in one step. Existing Conversation Statuses are reused. Only this row is saved; your other unsaved changes on this page are kept, but anything not yet applied in this editor is replaced.',
    he: 'יוצר סטטוס שיחה לכל אחת מ-{n} האפשרויות של "{p}" ומחבר כל אחד לאפשרות שלו במיפוי הערכים, בצעד אחד. סטטוסי שיחה קיימים משמשים שוב. רק השורה הזו נשמרת; שאר השינויים שלא נשמרו בעמוד נשארים, אך כל מה שעדיין לא הוחל בעורך זה יוחלף.',
  },
  crmOptionImportIncludeHidden: {
    en: 'Include options that are hidden in the CRM ({n})',
    he: 'לכלול אפשרויות שמוסתרות ב-CRM ({n})',
  },
  // OP-1508: the options come from the DISCOVERED schema, which is refreshed every few days, not from HubSpot live.
  crmOptionImportCatalogAge: {
    en: 'The options are read from the CRM schema discovered on {d}. Added an option in HubSpot since then? Press "Refresh schema" at the top of this page first.',
    he: 'האפשרויות נקראות מסכימת ה-CRM שנסרקה ב-{d}. הוספתם אפשרות ב-HubSpot מאז? לחצו קודם על "רענן סכימה" בראש העמוד.',
  },
  crmOptionImportErrMappingChanged: {
    en: 'The mapping was saved by someone else while the import ran, so it was not changed. Run the import again; repeating it is safe.',
    he: 'המיפוי נשמר על ידי מישהו אחר בזמן הייבוא, ולכן לא שונה. יש להריץ את הייבוא שוב; חזרה עליו בטוחה.',
  },
  crmOptionImportActivate: { en: 'Also turn this row on', he: 'להפעיל גם את השורה הזו' },
  crmOptionImportSubmit: { en: 'Import options from this property', he: 'ייבוא אפשרויות מהשדה' },
  crmOptionImporting: { en: 'Importing…', he: 'מייבא…' },
  crmOptionImportConfirmTitle: { en: 'Turn the row on?', he: 'להפעיל את השורה?' },
  crmOptionImportConfirmActivate: {
    en: 'When CRM writing is on, BotableX will write this conversation field into the HubSpot ticket property "{property}" on every ticket. Turn the row on?',
    he: 'כאשר הכתיבה ל-CRM פעילה, BotableX יכתוב את שדה השיחה הזה לשדה "{property}" בכל קריאה ב-HubSpot. להפעיל את השורה?',
  },
  crmOptionImportConfirmButton: { en: 'Import and turn on', he: 'ייבוא והפעלה' },
  crmOptionImportResultTags: {
    en: 'Tags: {created} created, {matched} matched; {row}',
    he: 'תגיות: {created} נוצרו, {matched} הותאמו; {row}',
  },
  crmOptionImportResultStatuses: {
    en: 'Conversation Status: {created} created, {matched} matched; {row}',
    he: 'סטטוס שיחה: {created} נוצרו, {matched} הותאמו; {row}',
  },
  // OP-1509: the import removes value-map entries whose option the portal no longer has; say how many.
  crmOptionImportRemoved: {
    en: '{n} value-map entries pointed at options that are no longer in the CRM and were removed. The tags and statuses themselves are kept.',
    he: '{n} רשומות במיפוי הערכים הצביעו על אפשרויות שכבר אינן ב-CRM והוסרו. התגיות והסטטוסים עצמם נשמרו.',
  },
  crmOptionImportRowOn: { en: 'the row is on.', he: 'השורה פעילה.' },
  crmOptionImportRowOff: { en: 'the row is off.', he: 'השורה כבויה.' },
  crmOptionImportErrGeneric: {
    en: 'The import failed. The mapping was not changed; some tags or statuses may already have been created, and repeating the import is safe.',
    he: 'הייבוא נכשל. המיפוי לא שונה; ייתכן שחלק מהתגיות או הסטטוסים כבר נוצרו, ואפשר לחזור על הייבוא בבטחה.',
  },
  crmOptionImportErrValidation: {
    en: 'The mapping was not saved. Fix these and try again:',
    he: 'המיפוי לא נשמר. יש לתקן את הבאים ולנסות שוב:',
  },
  crmOptionImportErrCrmPropertyRequired: { en: 'Choose a CRM property to import from.', he: 'יש לבחור שדה CRM לייבוא.' },
  crmOptionImportErrUnknownProperty: {
    en: 'That property is not in the discovered CRM schema. Refresh the schema and try again.',
    he: 'השדה אינו בסכימת ה-CRM שנסרקה. יש לרענן את הסכימה ולנסות שוב.',
  },
  crmOptionImportErrNotEnumeration: {
    en: 'Only list (enumeration) properties can be imported.',
    he: 'ניתן לייבא רק משדות מסוג רשימה.',
  },
  crmOptionImportErrNotWritable: { en: 'That property is read-only in the CRM.', he: 'השדה הוא לקריאה בלבד ב-CRM.' },
  crmOptionImportErrReserved: {
    en: 'That property is reserved by the integration and cannot be imported.',
    he: 'השדה שמור לאינטגרציה ולא ניתן לייבא ממנו.',
  },
  crmOptionImportErrTooManyOptions: {
    en: 'That property has too many options to import.',
    he: 'בשדה יש יותר מדי אפשרויות לייבוא.',
  },
  crmOptionImportErrNoOptions: { en: 'That property has no options to import.', he: 'לשדה אין אפשרויות לייבוא.' },
  crmOptionImportErrUnsupportedKey: {
    en: 'Options can only be imported for the conversation tags or conversation status field.',
    he: 'ניתן לייבא אפשרויות רק עבור שדה תגיות השיחה או סטטוס השיחה.',
  },
  crmOptionImportErrNoCatalog: {
    en: 'Refresh the CRM schema in Settings > CRM first.',
    he: 'יש לרענן קודם את סכימת ה-CRM בהגדרות > CRM.',
  },
  crmOptionImportErrRowTargetsOther: {
    en: 'The saved mapping already has a row for this field that points at a different CRM property. Change or remove that row, save, and import again.',
    he: 'במיפוי השמור כבר יש שורה לשדה הזה שמצביעה על שדה CRM אחר. יש לשנות או להסיר את השורה, לשמור ולייבא שוב.',
  },
  crmOptionImportErrTooManyTags: {
    en: 'The tag limit was reached, so the import stopped part-way. Some tags may already have been created, but the mapping was not changed. Deactivate tags you no longer use, or import fewer options, and try again.',
    he: 'הגעת למגבלת התגיות, ולכן הייבוא נעצר באמצע. ייתכן שחלק מהתגיות כבר נוצרו, אך המיפוי לא שונה. יש להשבית תגיות שאינן בשימוש, או לייבא פחות אפשרויות, ולנסות שוב.',
  },
  crmOptionImportErrTooManyStates: {
    en: 'The Conversation Status limit was reached, so the import stopped part-way. Some statuses may already have been created, but the mapping was not changed. Remove statuses you no longer use, or import fewer options, and try again.',
    he: 'הגעת למגבלת סטטוסי השיחה, ולכן הייבוא נעצר באמצע. ייתכן שחלק מהסטטוסים כבר נוצרו, אך המיפוי לא שונה. יש להסיר סטטוסים שאינם בשימוש, או לייבא פחות אפשרויות, ולנסות שוב.',
  },
  crmOptionImportErrTagCatalogUnavailable: {
    en: 'The tag list could not be reached, so the mapping was not changed. Try again in a moment.',
    he: 'לא ניתן היה לגשת לרשימת התגיות, ולכן המיפוי לא שונה. יש לנסות שוב בעוד רגע.',
  },
  crmOptionImportErrStateCatalogUnavailable: {
    en: 'The Conversation Status list could not be reached, so the mapping was not changed. Try again in a moment.',
    he: 'לא ניתן היה לגשת לרשימת סטטוסי השיחה, ולכן המיפוי לא שונה. יש לנסות שוב בעוד רגע.',
  },
} satisfies Record<string, { en: string; he: string }>;
